import type { IVoucher } from '@/entities/voucher'
import { useTranslation } from 'react-i18next'
import { SectionHeader } from '@/shared/ui/section-header'

interface VoucherStatsSectionProps {
  voucher: IVoucher
}

export function VoucherStatsSection({ voucher }: VoucherStatsSectionProps) {
  const { t } = useTranslation()

  return (
    <div>
      <SectionHeader title={t('voucher.sectionStats')} />
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
        <div className="rounded-lg border border-zinc-100 bg-zinc-50 p-4">
          <p className="text-xs text-zinc-500 mb-1">{t('voucher.issuedCount')}</p>
          <p className="text-2xl font-semibold text-zinc-900">
            {voucher.issuedCount.toLocaleString()}
          </p>
        </div>
        <div className="rounded-lg border border-zinc-100 bg-zinc-50 p-4">
          <p className="text-xs text-zinc-500 mb-1">{t('voucher.usedCount')}</p>
          <p className="text-2xl font-semibold text-zinc-900">
            {voucher.usedCount.toLocaleString()}
          </p>
        </div>
        <div className="rounded-lg border border-zinc-100 bg-zinc-50 p-4">
          <p className="text-xs text-zinc-500 mb-1">{t('voucher.remainingCount')}</p>
          <p className="text-2xl font-semibold text-emerald-600">
            {Math.max(0, voucher.quantity - voucher.issuedCount).toLocaleString()}
          </p>
        </div>
      </div>
    </div>
  )
}
